export default __webpack_public_path__ + "static/media/product_card_Hk.ccd0302f.webp";